/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplateListResponse {
    getFixupPrototypeFunction() { return TemplateListResponse.fixupPrototype; }

    static newInstance(model: Partial<TemplateListResponse>): TemplateListResponse {
        let obj = Object.assign(new TemplateListResponse(), model);
        TemplateListResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplateListResponse>): TemplateListResponse {
        if (!model) return null;
        return TemplateListResponse.newInstance(<TemplateListResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplateListResponse) {
        if (!obj) return;

        models.TemplateListResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplateListResponse): boolean {
        Object.setPrototypeOf(obj, TemplateListResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.templates) {
            models.TemplateDataModelList.fixupPrototype(this.templates);
        }
    }

    /**
     * Total number of templates available
     */
    total_templates: string;

    /**
     * Total number of pages
     */
    total_pages: string;

    /**
     * Template Metadata Info.
     */
    templates: models.TemplateDataModelList;

}
